const API_ROOT =
  (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_API_URL) || '';

const normalisedRoot = API_ROOT ? API_ROOT.replace(/\/$/, '') : '';

export const OWNERSHIP_API_BASE = normalisedRoot
  ? `${normalisedRoot}/api/ownership`
  : '/api/ownership';

const isAbsoluteBase =
  OWNERSHIP_API_BASE.startsWith('http://') ||
  OWNERSHIP_API_BASE.startsWith('https://');

export const ownershipApiUrl = (path: string = ''): string => {
  const normalisedPath = path.startsWith('/') ? path : `/${path}`;
  return `${OWNERSHIP_API_BASE}${normalisedPath}`;
};

export const resolveOwnershipApiUrl = (path: string = ''): string => {
  const url = ownershipApiUrl(path);
  if (isAbsoluteBase || typeof window === 'undefined') {
    return url;
  }
  return new URL(url, window.location.origin).toString();
};
